import { computed, type Ref } from 'vue';
import { useSwrPolling } from '@/utils/composables/useSwrPolling';
import { useUserInfo } from '@/utils/swr';

export const PERSONAL_NEWS_POLLING_INTERVAL_MS = 60 * 1000;

export const usePersonalNewsFeedPolling = (isPreparingFeed: Ref<boolean>) => {
  const { data: userInfo, mutate } = useUserInfo();

  const hasPersonalNews = computed(
    () => userInfo.value?.has_personal_news ?? false,
  );
  const shouldPoll = computed(
    () => isPreparingFeed.value && !hasPersonalNews.value,
  );

  useSwrPolling(mutate, shouldPoll, PERSONAL_NEWS_POLLING_INTERVAL_MS);

  return { hasPersonalNews };
};
